import { getLogger } from '@lib/observability/logging/log.client';
import type { DbClient } from '@lib/supabase/types';

const { logError } = getLogger(
  'lib/listing-import/services/upload-listing-import-source'
);

interface UploadListingImportSourceParams {
  supabase: DbClient;
  storagePath: string;
  file: File;
}

export async function uploadListingImportSource({
  supabase,
  storagePath,
  file,
}: UploadListingImportSourceParams): Promise<void> {
  const { error } = await supabase.storage
    .from('listing-imports')
    .upload(storagePath, file, {
      contentType: 'text/csv',
      upsert: true,
    });

  if (error) {
    const err = new Error(
      `Failed to upload listing import source: ${error.message}`
    );
    logError('Failed to upload listing import source', err);
    throw err;
  }
}
